import { Selection } from '@recogito/annotorious/src/tools/Tool';
import { SVG_NAMESPACE } from '@recogito/annotorious/src/util/SVG';
import {
  createEllipseElement,
  setEllipseSize,
  toEllipseTarget,
} from 'components/ImageViewer/annotorious/tools/ellipse/ellipseUtils';

/**
 * A 'rubberband' selection tool for creating an ellipse by
 * clicking and dragging.
 */
export default class RubberbandEllipse {
  constructor(anchorX, anchorY, g, config, env) {
    this.anchor = [anchorX, anchorY];
    this.opposite = [anchorX, anchorY];

    this.config = config;
    this.env = env;

    this.group = document.createElementNS(SVG_NAMESPACE, 'g');

    this.ellipse = createEllipseElement();
    this.ellipse.setAttribute('class', 'a9s-selection');
    setEllipseSize(this.ellipse, anchorX, anchorY, 2, 2);

    // Make the selection transparent to pointer events and hide it until
    // the user actually moves the mouse (same as the built-in tools).
    this.group.style.pointerEvents = 'none';
    this.group.style.display = 'none';

    this.group.appendChild(this.ellipse);

    g.appendChild(this.group);
  }

  get bbox() {
    const w = this.opposite[0] - this.anchor[0];
    const h = this.opposite[1] - this.anchor[1];

    return {
      x: w > 0 ? this.anchor[0] : this.opposite[0],
      y: h > 0 ? this.anchor[1] : this.opposite[1],
      w: Math.max(1, Math.abs(w)),
      h: Math.max(1, Math.abs(h)),
    };
  }

  get element() {
    return this.ellipse;
  }

  dragTo = (oppositeX, oppositeY) => {
    this.group.style.display = null;

    this.opposite = [oppositeX, oppositeY];
    const { x, y, w, h } = this.bbox;

    setEllipseSize(this.ellipse, x, y, w, h);
  };

  getBoundingClientRect = () => this.ellipse.getBoundingClientRect();

  toSelection = () => {
    const { x, y, w, h } = this.bbox;

    return new Selection(toEllipseTarget(x, y, w, h, this.env.image));
  };

  destroy = () => {
    this.group.parentNode.removeChild(this.group);

    this.ellipse = null;
    this.group = null;
  };
}
